(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const init = (root = document) => {
    root.querySelectorAll('.spn-main media-gallery').forEach(gallery=>{
      if(gallery.dataset.spnArrowReady)return;gallery.dataset.spnArrowReady='true';
      gallery.querySelectorAll('[data-spn-gallery-step]').forEach(button=>button.addEventListener('click',()=>{
        const thumbnails=[...gallery.querySelectorAll('media-dots button')].filter(x=>!x.hidden);
        const selected=thumbnails.findIndex(x=>x.getAttribute('aria-current')==='true');
        thumbnails[(selected+Number(button.dataset.spnGalleryStep)+thumbnails.length)%thumbnails.length]?.click();
      }));
    });
    // Native disclosure semantics with the reference page's 500 ms expansion.
    root.querySelectorAll('.spn-replica details').forEach(details => {
      if (details.dataset.spnDisclosureReady) return;
      details.dataset.spnDisclosureReady = 'true';
      const summary = details.querySelector('summary'), body = details.querySelector('.gp-accordion-item_body');
      if (!summary || !body) return;
      details.classList.toggle('spn-expanded', details.open);
      let animation;
      summary.addEventListener('click', event => {
        event.preventDefault();
        const opening = !details.classList.contains('spn-expanded');
        const from = details.open ? body.getBoundingClientRect().height : 0;
        animation?.cancel();
        details.open = true;
        details.classList.toggle('spn-expanded', opening);
        const to = opening ? body.scrollHeight : 0;
        if (reduced.matches || event.detail === 0) { details.open = opening; body.style.removeProperty('overflow'); return; }
        body.style.setProperty('overflow','hidden','important');
        animation = body.animate([{ height: from + 'px' }, { height: to + 'px' }], { duration: 500, easing: 'cubic-bezier(.4,0,.2,1)' });
        animation.finished.then(() => { details.open = opening; body.style.removeProperty('overflow'); }).catch(() => {});
      });
    });
    // Count and fill once, starting when 10% enters the viewport, as on the source.
    root.querySelectorAll('[data-spn-count], .spn-replica .pb-fill').forEach(el => {
      if (el.dataset.spnCountReady) return;
      el.dataset.spnCountReady = 'true';
      if (reduced.matches) return;
      const isCount = el.hasAttribute('data-spn-count');
      const final = Number(el.dataset.spnCount);
      if (isCount) el.textContent = '0';
      else { el.style.transformOrigin = 'left center'; el.style.transform = 'scaleX(0)'; }
      const observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        observer.disconnect();
        let start;
        const frame = time => {
          start ??= time;
          const p = Math.min((time - start) / 1800, 1);
          const eased = p < .5 ? 2*p*p : -1+(4-2*p)*p;
          if (isCount) el.textContent = String(Math.round(final * eased));
          else el.style.transform = `scaleX(${eased})`;
          if (p < 1 && !reduced.matches) requestAnimationFrame(frame);
          else { if(isCount) el.textContent = String(final); else el.style.transform = ''; }
        };
        requestAnimationFrame(frame);
      }, {threshold:.1});
      observer.observe(el);
    });
    root.querySelectorAll('.gps_timeline-section').forEach(timeline => {
      if (timeline.dataset.spnTimelineReady) return;
      timeline.dataset.spnTimelineReady = 'true';
      const items = [...timeline.querySelectorAll('.gps_timeline-item')];
      const first = items[0], icons = [...timeline.querySelectorAll('.gps_timeline-icon')];
      if (!first || !icons.length) return;
      let queued = false;
      const update = () => {
        queued = false;
        const trigger = innerHeight * .6;
        items.forEach(item => item.classList.toggle('viewing', reduced.matches || item.getBoundingClientRect().top < trigger));
        const firstTop = first.getBoundingClientRect().top;
        const last = icons.at(-1).getBoundingClientRect();
        const full = last.top + last.height / 2 - firstTop + 200;
        first.style.setProperty('--timeline-full-height', full + 'px');
        first.style.setProperty('--timeline-height-dynamic', Math.min(Math.max(trigger-firstTop,0),full)+'px');
      };
      const queue = () => { if (!queued) { queued = true; requestAnimationFrame(update); } };
      addEventListener('scroll',queue,{passive:true});addEventListener('resize',queue,{passive:true});
      new ResizeObserver(queue).observe(timeline);update();
    });
    root.querySelectorAll('[data-spn-carousel], .spn-replica gp-carousel-v3').forEach(car => {
      if (car.dataset.spnReady) return;
      car.dataset.spnReady = 'true';car.setAttribute('data-spn-carousel','');
      const track = car.querySelector('[data-spn-track], .gem-slider-wrapper');
      if (!track) return;track.setAttribute('data-spn-track','');
      const step = () => { const item = track.querySelector('.gem-slider-item'); return item ? item.getBoundingClientRect().width + parseFloat(getComputedStyle(item).marginRight || 0) : track.clientWidth; };
      let frameId;
      const stop = () => { cancelAnimationFrame(frameId); track.style.removeProperty('scroll-snap-type'); };
      const easeIn = progress => { let lo=0,hi=1,t=progress;for(let n=0;n<12;n++){t=(lo+hi)/2;const x=3*(1-t)*(1-t)*t*.42+3*(1-t)*t*t+t*t*t;if(x<progress)lo=t;else hi=t;}return 3*(1-t)*t*t+t*t*t; };
      const slideTo = left => {
        stop();left=Math.max(0,Math.min(left,track.scrollWidth-track.clientWidth));
        if(reduced.matches){track.scrollLeft=left;return;}
        const from=track.scrollLeft;let start;
        track.style.setProperty('scroll-snap-type','none','important');
        const frame=time=>{start??=time;const progress=Math.min((time-start)/500,1);track.scrollLeft=from+(left-from)*easeIn(progress);if(progress<1)frameId=requestAnimationFrame(frame);else{track.scrollLeft=left;stop();}};
        frameId=requestAnimationFrame(frame);
      };
      track.addEventListener('pointerdown',stop,{passive:true});track.addEventListener('wheel',stop,{passive:true});
      const move = direction => { const end = track.scrollWidth - track.clientWidth; let left = track.scrollLeft + direction * step(); if (innerWidth<=767) {if(left>end+4)left=0;if(left< -4)left=end;}slideTo(left); };
      car.querySelector('[data-spn-prev], [aria-label="Carousel Back Arrow"]')?.addEventListener('click',()=>move(-1));
      car.querySelector('[data-spn-next], [aria-label="Carousel Next Arrow"]')?.addEventListener('click',()=>move(1));
      const dots = car.querySelector('[class*="gp-carousel-dot-container-"]');
      if (dots && !dots.children.length) {
        [...track.children].forEach((_,i)=> { const dot=document.createElement('button');dot.type='button';dot.className='gp-carousel-dot';dot.setAttribute('aria-label',`Go to slide ${i+1}`);dot.style.cssText='width:9px;height:9px;border-radius:50%';dot.addEventListener('click',()=>slideTo(i*step()));dots.append(dot); });
      }
      if (dots) {
        const updateDots = () => { const last = track.scrollWidth - track.clientWidth; dots.style.display = last > 2 ? '' : 'none'; const index = track.scrollLeft >= last - 2 ? dots.children.length - 1 : Math.round(track.scrollLeft / step()); [...dots.children].forEach((dot,i)=>dot.setAttribute('aria-current',String(i===index))); };
        track.addEventListener('scroll',updateDots,{passive:true});new ResizeObserver(updateDots).observe(track);updateDots();
      }
    });
    root.querySelectorAll('[data-spn-tabs]').forEach(tabs => {
      if(tabs.dataset.spnReady)return;tabs.dataset.spnReady='true';
      const controls=[...tabs.querySelectorAll('[data-spn-tab]')],panels=[...tabs.querySelectorAll('[data-spn-panel]')];
      const select=i=>{controls.forEach((b,j)=>{b.setAttribute('aria-selected',String(i===j));b.tabIndex=i===j?0:-1});panels.forEach((p,j)=>{p.hidden=i!==j});};
      controls.forEach((button,i)=>{button.addEventListener('click',()=>select(i));button.addEventListener('keydown',e=>{let next=i;if(e.key==='ArrowRight')next=(i+1)%controls.length;else if(e.key==='ArrowLeft')next=(i-1+controls.length)%controls.length;else if(e.key==='Home')next=0;else if(e.key==='End')next=controls.length-1;else return;e.preventDefault();select(next);controls[next].focus();});});select(0);
    });
    root.querySelectorAll('.spn-replica .ag-acc__card').forEach(card=>{
      if(card.dataset.spnReady)return;card.dataset.spnReady='true';
      card.addEventListener('click',()=>{const open=!card.classList.contains('is-open');card.closest('.ag-acc').querySelectorAll('.ag-acc__card').forEach(c=>{c.classList.remove('is-open');c.setAttribute('aria-expanded','false')});card.classList.toggle('is-open',open);card.setAttribute('aria-expanded',String(open));if(open)card.style.setProperty('--spn-card-height',Math.max(150,card.querySelector('.ag-acc__back-inner').scrollHeight)+'px');});
    });
    root.querySelectorAll('.spn-replica .rfm-initial-child-container').forEach(row=>{
      if(row.dataset.spnReady)return;row.dataset.spnReady='true';
      const originals=[...row.children],width=row.getBoundingClientRect().width;
      const copies=width>0?Math.max(1,Math.ceil(innerWidth/width)):1;
      for(let n=1;n<copies;n++)originals.forEach(item=>{const c=item.cloneNode(true);c.setAttribute('aria-hidden','true');row.append(c)});
      const duplicate=row.cloneNode(true);duplicate.setAttribute('aria-hidden','true');row.parentElement.append(duplicate);
      // The source moves both strips at 30 px/s, independent of viewport width.
      const measure=()=>row.parentElement.style.setProperty('--spn-marquee-duration',(row.getBoundingClientRect().width/30)+'s');
      new ResizeObserver(measure).observe(row);measure();
    });
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
  document.addEventListener('shopify:section:load',e=>init(e.target));
})();
